// Mexican Spanish (es-MX) translations.
// Keyed by the English source string so any wrapped string falls back gracefully
// to English when a translation is not present.
export const translations = {
  es: {
    // ---- Sidebar / navigation ----
    "Assets": "Unidades",
    "DVIR": "DVIR",
    "Service Request": "Solicitud de Servicio",
    "Parts": "Refacciones",
    "Reports": "Reportes",
    "Settings": "Configuración",
    "Users": "Usuarios",
    "Sign Out": "Cerrar Sesión",
    "Fleet Maintenance": "Mantenimiento de Flota",
    "Help Center": "Centro de Ayuda",
    "Guides & documentation for the app": "Guías y documentación de la aplicación",
    "Search help topics...": "Buscar temas de ayuda...",
    "No topics match your search": "Ningún tema coincide con tu búsqueda",
    "Full Guide (PDF)": "Guía Completa (PDF)",
    "topic(s)": "tema(s)",

    // ---- Common ----
    "Save": "Guardar",
    "Cancel": "Cancelar",
    "Add": "Agregar",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "Delete": "Eliminar",
    "Deleted": "Eliminado",
    "Are you sure?": "¿Estás seguro?",
    "This removes it from active lists. The record is kept in the audit trail.": "Esto lo quita de las listas activas. El registro se conserva en la auditoría.",
    "Search": "Buscar",
    "Close": "Cerrar",
    "Loading...": "Cargando...",
    "Notes": "Notas",
    "Status": "Estado",
    "Quantity": "Cantidad",
    "Unit": "Unidad",
    "Vendor": "Proveedor",
    "Location": "Ubicación",
    "Description": "Descripción",
    "Category": "Categoría",
    "Priority": "Prioridad",
    "Save Changes": "Guardar Cambios",
    "entries": "registros",
    "All Transaction Types": "Todos los Tipos de Movimiento",
    "No transactions recorded": "Sin movimientos registrados",

    // ---- Settings ----
    "Service Intervals": "Intervalos de Servicio",
    "Configure when services are due": "Configura cuándo vencen los servicios",
    "Manage service intervals and configurations": "Administra intervalos de servicio y configuraciones",
    "Add Interval": "Agregar Intervalo",
    "Language": "Idioma",
    "App Language": "Idioma de la Aplicación",
    "Choose the language for the entire app.": "Elige el idioma para toda la aplicación.",
    "English": "Inglés",
    "Spanish (Mexico)": "Español (México)",

    // ---- Login ----
    "Sign In": "Iniciar Sesión",
    "Signing in...": "Iniciando sesión...",
    "Enter your 4-digit PIN": "Ingresa tu PIN de 4 dígitos",
    "Don't have an account?": "¿No tienes una cuenta?",
    "Request Access": "Solicitar Acceso",
    "Invalid PIN": "PIN inválido",
    "Please enter a 4-digit PIN": "Por favor ingresa un PIN de 4 dígitos",

    // ---- Parts & Inventory module ----
    "Parts & Inventory": "Refacciones e Inventario",
    "Track parts, costs, and chain of custody across the fleet": "Controla refacciones, costos y la cadena de custodia en toda la flota",
    "Guide": "Guía",
    "Dashboard": "Panel",
    "Inventory": "Inventario",
    "Procurement": "Compras",
    "Core Tracking": "Seguimiento de Cores",
    "Counts & Ledger": "Conteos y Movimientos",
    "Vendors": "Proveedores",

    // sub-tabs
    "Parts Inventory": "Inventario de Refacciones",
    "Salvaged": "Rescatadas",
    "Tires": "Llantas",
    "Locations": "Ubicaciones",
    "Requests": "Solicitudes",
    "Parts Requests": "Solicitudes de Refacciones",
    "Purchase Orders": "Órdenes de Compra",
    "Receive": "Recibir",
    "Receive Parts": "Recibir Refacciones",
    "Adjustments": "Ajustes",
    "Cycle Counts": "Conteos Cíclicos",
    "Ledger": "Movimientos",
    "Audit Trail": "Registro de Auditoría",

    // permission tiers
    "Admin": "Administrador",
    "Parts Manager": "Gerente de Refacciones",
    "Mechanic": "Mecánico",
    "Viewer": "Solo Lectura",

    // ---- Dashboard ----
    "Total Inventory Value": "Valor Total del Inventario",
    "Actual": "Real",
    "Estimated": "Estimado",
    "Verified": "Verificado",
    "Total Parts": "Total de Refacciones",
    "Low Stock": "Existencias Bajas",
    "Out of Stock": "Agotado",
    "Core Money At Risk": "Dinero en Cores en Riesgo",
    "open core(s)": "core(s) abierto(s)",
    "Open Requests": "Solicitudes Abiertas",
    "Truck Down": "Unidad Parada",
    "Open POs": "Órdenes Abiertas",
    "Low Stock Items": "Artículos con Existencias Bajas",
    "All stock levels healthy": "Todos los niveles de existencia están bien",
    "Recent Activity": "Actividad Reciente",
    "No recent activity": "Sin actividad reciente",
    "Received": "Recibido",
    "Tires:": "Llantas:",
    "Salvage:": "Rescate:",

    // ---- Common section buttons ----
    "Add Part": "Agregar Refacción",
    "Add Vendor": "Agregar Proveedor",
    "Add Location": "Agregar Ubicación",
    "Add Tire": "Agregar Llanta",
    "Add Salvaged Part": "Agregar Refacción Rescatada",
    "New Request": "Nueva Solicitud",
    "New PO": "Nueva Orden",
    "Add Core": "Agregar Core",
    "Install on Unit": "Instalar en Unidad",
    "Issue": "Entregar",
    "Adjust": "Ajustar",
    "parts": "refacciones",
    "vendors": "proveedores",
    "locations": "ubicaciones",
    "tires": "llantas",
    "receipts": "recibos",

    // ---- Part statuses ----
    "In Stock": "En Existencia",
    "Ordered": "Pedido",
    "Discontinued": "Descontinuado",

    // ---- Request priorities / statuses ----
    "Submitted": "Enviada",
    "Under Review": "En Revisión",
    "Approved": "Aprobada",
    "Reserved": "Reservada",
    "Need to Purchase": "Por Comprar",
    "Part Received": "Refacción Recibida",
    "Issued": "Entregada",
    "Installed": "Instalada",
    "Closed": "Cerrada",
    "Denied": "Rechazada",
    "Cancelled": "Cancelada",

    // ---- Core statuses ----
    "Pending Return": "Pendiente de Devolución",
    "Returned": "Devuelto",
    "Credit Pending": "Crédito Pendiente",
    "Credit Received": "Crédito Recibido",
    "Lost": "Perdido",
  },
};

export const t = (text, lang) => {
  if (!lang || lang === "en") return text;
  const dict = translations[lang] || {};
  return dict[text] ?? text;
};
